// extracted by mini-css-extract-plugin
export default {"buttons":"_90ae3bdfb8b8cfc7","codeColumn":"_597749b9f985cb5b"};